package com.tfc.care.tfccare.ui

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.lifecycle.compose.collectAsStateWithLifecycle

@Composable
fun StaffApp(
    viewModel: StaffChatViewModel,
    onImagePick: () -> Unit,
    imageLoader: @Composable (String) -> Unit,
    showMessage: (String) -> Unit,
) {
    val currentStaff by viewModel.staff.collectAsStateWithLifecycle()
    val staffId = currentStaff?.id

    // Added a small side effect to observe staff changes and trigger logic if needed
    // In fact, viewModel already handles it via checkPersistence and signIn

    var showImage by remember { mutableStateOf<String?>(null) }

    val chatState by viewModel.chatState.collectAsState()

    LaunchedEffect(Unit) {
        viewModel.checkPersistence()
    }

    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colorScheme.background
    ) {
         if (currentStaff == null) {
            StaffLoginScreen(
                isDarkTheme=chatState.isDarkTheme,
                onLogin = { email, password ->
                    viewModel.signIn(email, password)
                },
                isLoading = chatState.isLoading,
                error = chatState.error
            )
        }
        else if (!currentStaff!!.isValid) {
            // Show something else or login with error if staff profile is invalid
            StaffLoginScreen(
                isDarkTheme=chatState.isDarkTheme,
                onLogin = { email, password ->
                    viewModel.signIn(email, password)
                },
                isLoading = chatState.isLoading,
                error = "Access denied: Invalid staff profile."
            )
        }
        else {
            if(showImage.isNullOrEmpty()){
                StaffChatScreen(
                    viewModel = viewModel,
                    onLogOut={
                        viewModel.logout()
                    },
                    onImagePick = onImagePick,
                    imageLoader = imageLoader,
                    showMessage = { msg ->
                        showMessage(msg)
                    },
                    onImageClick = { url ->
                        showImage = url
                    },
                )
            }else{
                ImageScreen(url = showImage){
                    showImage = null
                }
            }
        }
    }
}